/**
 * Exhaustive check helper for discriminated unions.
 * Use at the end of switch statements or if/else chains to get a compile-time error
 * when a new variant is added but not handled.
 *
 * @example
 * switch (item.type) {
 *   case "a": return handleA(item);
 *   case "b": return handleB(item);
 *   default: return assertNever(item.type);
 * }
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled discriminated union member: ${JSON.stringify(value)}`);
}
